<template>
    <div class="container remove-padding-margin">
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back">
                    <img src="../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">Pengaturan Komisi Sales</h6>
                </div>
                <div class="col-md-2 col-sm-2 col-2">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SalesSet",
        data(){
            return{
                idkaryawan:''
            }
        },
        mounted(){
            this.idkaryawan = this.$route.params.idkaryawan
        },
        methods:{
            back(){
                this.$router.push({name: 'detailkaryawan'})
            },
        }
    }
</script>

<style scoped>

</style>